import { useOutletContext } from 'react-router-dom';
import {
  AccessComponentEnum,
  AccessLevelEnum,
  CompanyPlanUpgradeFeatureEnum,
  User,
} from 'graphql-common';
import { PlanState } from '@lib/enums/plan';
import { ScannerActionType } from 'routes/Scanner/enums';

export type ContextProps = {
  closeScanner: () => void;
  getUserAccessByCompany: (component: AccessComponentEnum) => AccessLevelEnum;
  getUserAccessByComponent: (component: AccessComponentEnum) => AccessLevelEnum;
  getUserAccessByUrl: (pathname: string) => AccessLevelEnum;
  getUserAccessItemIdsByComponent: (component: AccessComponentEnum) => string[];
  handleOpenPlanModal: (
    state: PlanState,
    features?: CompanyPlanUpgradeFeatureEnum[],
  ) => void;
  logoutLoading: boolean;
  onLogoutHandler: () => void;
  openScanner: (v: ScannerActionType | undefined) => void;
  tasksSyncLoading: boolean;
  user: User;
};

export default function useOutletContextHook() {
  const outletContext: ContextProps = useOutletContext();
  return outletContext;
}
